/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface CreateProductBankItemDto
 */
export interface CreateProductBankItemDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    upc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    ndc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    drugType: CreateProductBankItemDtoDrugTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    dosageForm?: CreateProductBankItemDtoDosageFormEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    strength?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductBankItemDto
     */
    activeIngredients?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBankItemDto
     */
    subCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductBankItemDto
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductBankItemDto
     */
    images?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateProductBankItemDtoDrugTypeEnum {
    OTC = 'OTC',
    RX = 'RX',
    SUPPLEMENT = 'SUPPLEMENT',
    GENERAL = 'GENERAL'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateProductBankItemDtoDosageFormEnum {
    TABLET = 'TABLET',
    CAPSULE = 'CAPSULE',
    LIQUID = 'LIQUID',
    CREAM = 'CREAM',
    GEL = 'GEL',
    SPRAY = 'SPRAY',
    PATCH = 'PATCH',
    DROPS = 'DROPS',
    POWDER = 'POWDER',
    CHEWABLE = 'CHEWABLE',
    OTHER = 'OTHER'
}

